export const MANAGED_CONNECTIONS_HELP_URL =
  "https://help.zapier.com/hc/en-us/articles/48885520819597-Create-managed-connections-from-the-Connections-page";

export const MANAGED_CONNECTION_NUDGE_DISMISSED =
  "managedConnectionNudgeDismissed";

export const CONNECTION_STATUS_DISABLED = "disabled";
